var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.987 10.97c.617-2.954 3.199-5.052 6.103-5.052s5.485 2.098 6.103 5.052a.45.45 0 0 0 .536.35.453.453 0 0 0 .351-.534c-.703-3.36-3.646-5.77-6.99-5.77s-6.287 2.41-6.99 5.77a.45.45 0 0 0 .35.534.455.455 0 0 0 .537-.35M9.09 7.722c-.84 0-1.647.332-2.241.924a3.15 3.15 0 0 0 0 4.465 3.176 3.176 0 0 0 4.482 0 3.15 3.15 0 0 0 0-4.465 3.18 3.18 0 0 0-2.241-.924m-2.264 3.156c0-.598.239-1.171.663-1.594a2.27 2.27 0 0 1 3.202 0 2.25 2.25 0 0 1 0 3.189 2.27 2.27 0 0 1-3.202 0 2.25 2.25 0 0 1-.663-1.595"
  })));
};
export default SvgEye;